import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { InstrumentNameCell } from '@/modules/trade/components/InstrumentNameCell';
import { MoneyCell } from '@/modules/common/components/MoneyCell';
import { InstrumentPriceCell } from '@/modules/trade/components/InstrumentPriceCell';

import { PortfolioSectionStockItem } from '@/modules/wealth/services/portfolio';

export const columns = [
  {
    label: 'Ativo',
    component: InstrumentNameCell,
    getter: (item: PortfolioSectionStockItem) => ({
      symbol: item.symbol,
      name: item.name || '-',
      type: item.type,
      size: 'small',
      hasEllipsis: true
    })
  },
  {
    label: 'Quantidade',
    align: 'right',
    component: MoneyCell,
    getter: (item: PortfolioSectionStockItem) => ({
      text: item.quantity,
      align: 'right',
      color: NebraskaColors.elementDisabled
    })
  },
  {
    label: 'Saldo total',
    align: 'right',
    component: MoneyCell,
    getter: (item: PortfolioSectionStockItem) => ({
      text: item.balance.formatted,
      align: 'right',
      color: NebraskaColors.elementDisabled
    })
  },
  {
    label: 'Rentabilidade',
    align: 'right',
    component: InstrumentPriceCell,
    getter: (item: PortfolioSectionStockItem) => ({
      price: item.inceptionProfits.amount,
      percentual: item.inceptionProfits.percentage,
      size: 'small',
      align: 'right',
      enableToggleMoney: true,
      color: NebraskaColors.elementDisabled
    })
  },
  {
    label: 'Peso na carteira',
    align: 'right',
    getter: (item: PortfolioSectionStockItem) =>
      item.percentageAllocatedOnPortfolio.formatted
  }
];
